module.exports = __webpack_public_path__ + "img/IMG_1128.9d3ac3f8.jpeg";